import * as React from 'react';
import { Outlet, Link } from "react-router-dom";
import styled from 'styled-components';

const NewsContainer = styled.div`
  width: 100%;
  padding: 5px 20px;
`;

const NewsTitle = styled.div`
  font-weight: bold;
  padding: 8px 5px;
  background-color: #EFEFEF;
  border-bottom: 1px solid #CCCCCC;
`;

const NewsContent = styled.div`
  padding: 8px;
`;

const Home = () => {
  return (
    <>
      <div>
      <NewsContainer>
          <NewsTitle>Zmiany technologiczne</NewsTitle>
          <NewsContent>
            Serwis został przepisany do technologii React oraz został zmieniony hosting z uwagi na koszty. Mogą być jeszcze niedociągnięcia, które będę stopniowo poprawiał.
          </NewsContent>
        </NewsContainer>
        <NewsContainer>
          <NewsTitle>Test z synonimów</NewsTitle>
          <NewsContent>
            Dostępny jest nowy typ testu - test z synonimów. Idea jest prosta - należy wybrać odpowiedź, która jest synonimem
            podanego słowa. Samych możliwych pytań jest <b>4825</b>!<br/>Zapraszam do działu <Link to="/test"><b>testy</b></Link>.
          </NewsContent>
        </NewsContainer>
        <NewsContainer>
          <NewsTitle>Kolejna porcja testów</NewsTitle>
          <NewsContent>
            Pojawiły się nowe kategorie testów, a wraz z nimi pytania testowe, których liczba przekroczyła magiczny <b>1000</b>.<br/>
            Zapraszam do działu <Link to="/test"><b>testy</b></Link>.
          </NewsContent>
        </NewsContainer>
        <NewsContainer>
          <NewsTitle>Nowe testy</NewsTitle>
          <NewsContent>
            Liczba pytań testowych przekroczyła <b>500</b>. Pełną listę dostępnych testów można znaleźć w dziale <Link to="/test"><b>testy</b></Link>.
          </NewsContent>
        </NewsContainer>
        <NewsContainer>
          <NewsTitle>Testy</NewsTitle>
          <NewsContent>
            Po długiej przerwie serwis wzbogacił się o nowy dział. Jest nim dział <Link to="/test"><b>testy</b></Link>, które mają umożliwić sprawdzenie znajomości języka hiszpańskiego.<br/>
            Na razie jest ich niewiele, ale sukcesywnie będę umieszczał kolejne. Podziękowania dla osób, które je przygotowały. Wszelkie uwagi i komentarze mile widziane.<br/><br/>
            Dodatkowo serwis zmienił się od strony "kuchni" - zostało użyte oprogramowanie (framework) 
            <a href="https://www.codeigniter.com" target="_blank"><b>Code Igniter</b></a>, które ma umożliwić szybsze wprowadzanie zmian
            w serwisie oraz usprawnić jego działanie. Zmiana dotyczyła całego serwisu, stąd mogą się w nim pojawić błędy. W
            przypadku ich zauważenia proszę o poinformowanie o nich. Z góry dziękuję. <b>Uwaga! Zmianie uległy adresy podstron.</b><br/><br/>
            Zostało również poprawionych kilka błędów znalezionych na stronie. Ze względu na bycie "martwym" zniknęło
            również forum.
          </NewsContent>
        </NewsContainer>
        <NewsContainer>
          <NewsTitle>O języku hiszpańskim</NewsTitle>
          <NewsContent>
            Dodany został tekst o <Link to="/lang"><b>języku hiszpańskim</b></Link>.
          </NewsContent>
        </NewsContainer>
      </div>
      <Outlet />
    </>
  );
};

export default Home;